import * as React from 'react';

import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { Field, GraphTooltip } from '../../GraphTooltip/GraphTooltip';

interface Props {
  tooltipProps: TooltipProps<ValueType, NameType>;
  showHistoric: boolean;
}

const getFields: (showHistoric: boolean) => Field[] = (showHistoric) => {
  return [
    { field: 'current.disputable', variant: 'disputable', isPast: false },
    { field: 'current.nonDisputable', variant: 'non-disputable', isPast: false },
    ...(showHistoric
      ? [
          { field: 'historic.disputable', variant: 'disputable' as const, isPast: true },
          { field: 'historic.nonDisputable', variant: 'non-disputable' as const, isPast: true },
        ]
      : []),
  ];
};

export const HoverTooltip: React.FC<Props> = (props) => {
  const { tooltipProps, showHistoric } = props;
  const { payload } = tooltipProps;

  const fields = React.useMemo(() => {
    const rawFields = getFields(showHistoric);
    return rawFields.map((f) => {
      const value = payload?.find((p) => p.name === f.field)?.value as number | undefined;
      return {
        ...f,
        value,
      };
    });
  }, [showHistoric, payload]);

  return <GraphTooltip fields={fields} />;
};
HoverTooltip.displayName = 'HoverTooltip';
